import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { useState } from 'react';

interface Props {
	steps: Step[];
	initialStepIndex?: number;
}

export const useKycSteps = ({ steps, initialStepIndex }: Props) => {
	const [currentStepIndex, setCurrentStepIndex] = useState(() => {
		if (
			initialStepIndex !== undefined &&
			initialStepIndex >= 0 &&
			initialStepIndex < steps.length
		) {
			return initialStepIndex;
		}
		return 0;
	});

	const currentStep = steps[currentStepIndex] ?? null;

	const canMoveToNextStep = currentStepIndex < steps.length - 1;

	const canMoveToPreviousStep = currentStepIndex > 0;

	const moveToStep = (stepIndex: number) => {
		if (stepIndex >= 0 && stepIndex < steps.length) {
			setCurrentStepIndex(stepIndex);
		}
	};

	const moveToNextStep = () => {
		if (canMoveToNextStep) {
			setCurrentStepIndex((prev) => prev + 1);
		}
	};

	const moveToPreviousStep = () => {
		if (canMoveToPreviousStep) {
			setCurrentStepIndex((prev) => prev - 1);
		}
	};

	return {
		currentStep,
		currentStepIndex,
		moveToStep,
		moveToNextStep,
		moveToPreviousStep,
		canMoveToNextStep,
		canMoveToPreviousStep,
	};
};
